const LocalStorage = {
  user: 'user',
  accessToken: 'accessToken',
  cart: 'cart'
}
export default LocalStorage
